export class ReferenceModel {
  public Year?: number;
  public Month?: number;
}
